import type { ComponentType } from "react";
import {
  LayoutDashboard,
  BedDouble,
  CalendarDays,
  ClipboardList,
  History,
  Users,
  MessageSquare,
  Ticket,
  Sparkles,
  Home,
  CreditCard,
  BookOpen,
  ClockAlert,
  Warehouse,
  Mail,
  FileSpreadsheet,
  Landmark,
} from "lucide-react";
import type { UserRole } from "../types/auth";

export interface NavItem {
  path: string;
  label: string;
  icon: ComponentType<{ size?: number; className?: string }>;
  roles: UserRole[];
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

// Nguồn duy nhất cho cả thanh bên (Layout) lẫn chặn quyền theo đường dẫn (App)
export const NAV_GROUPS: NavGroup[] = [
  {
    title: "Tổng quan",
    items: [
      { path: "/", label: "Tổng quan", icon: LayoutDashboard, roles: ["roommaster", "admin", "superadmin"] },
    ],
  },
  {
    title: "Vận hành",
    items: [
      { path: "/calendar",     label: "Lịch đặt phòng",         icon: CalendarDays,    roles: ["roommaster", "kiemkho", "admin", "superadmin"] },
      { path: "/bookings",     label: "Đơn đặt phòng",          icon: ClipboardList,   roles: ["roommaster", "admin", "superadmin"] },
      { path: "/transactions", label: "Giao dịch chuyển khoản", icon: Landmark,        roles: ["admin", "superadmin"] },
      { path: "/lld-review",   label: "Duyệt giờ LLD",          icon: ClockAlert,      roles: ["admin", "superadmin"] },
      { path: "/lld-revenue",  label: "Doanh thu LLD",          icon: FileSpreadsheet, roles: ["admin", "superadmin"] },
    ],
  },
  {
    title: "Phòng & kho",
    items: [
      { path: "/rooms",     label: "Quản lý phòng",   icon: BedDouble, roles: ["admin", "superadmin"] },
      { path: "/guide",     label: "Hướng dẫn phòng", icon: BookOpen,  roles: ["kiemkho", "admin", "superadmin"] },
      { path: "/warehouse", label: "Quản lý kho",     icon: Warehouse, roles: ["kiemkho", "admin", "superadmin"] },
    ],
  },
  {
    title: "Khách hàng",
    items: [
      { path: "/users",    label: "Người dùng",      icon: Users,         roles: ["admin", "superadmin"] },
      { path: "/comments", label: "Bình luận",       icon: MessageSquare, roles: ["admin", "superadmin"] },
      { path: "/vouchers", label: "Voucher",         icon: Ticket,        roles: ["admin", "superadmin"] },
      { path: "/spin",     label: "Quay số may mắn", icon: Sparkles,      roles: ["admin", "superadmin"] },
    ],
  },
  {
    title: "Hệ thống",
    items: [
      { path: "/site-settings",    label: "Trang chủ",         icon: Home,       roles: ["admin", "superadmin"] },
      { path: "/payment-settings", label: "Thanh toán",        icon: CreditCard, roles: ["superadmin"] },
      { path: "/netflix-mail",     label: "Mail Netflix",      icon: Mail,       roles: ["admin", "superadmin"] },
      { path: "/edit-history",     label: "Lịch sử chỉnh sửa", icon: History,    roles: ["superadmin"] },
    ],
  },
];

export const NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((g) => g.items);

// Quyền cho từng đường dẫn; trang con (vd /warehouse/:id) dùng quyền của trang cha
export function rolesForPath(path: string): UserRole[] | null {
  const p = "/" + path.replace(/^\//, "").split("/")[0];
  return NAV_ITEMS.find((i) => i.path === p)?.roles ?? null;
}

// Trang đầu tiên mỗi vai trò được phép vào
export function landingForRole(role?: UserRole): string {
  if (role === "kiemkho") return "/calendar";
  return "/";
}
